import QualiteSelect from '@/generated/controls/qualite/QualiteSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: QualiteSelect
})
